import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

const TemplateFilters = ({
  isUsingTemplateFilter,
  toggleIsUsingTemplateFilter,
  templateFilters,
  setTemplateFilters,
  templates,
}) => {
  const handleToggleTemplateFilter = () => {
    toggleIsUsingTemplateFilter(!isUsingTemplateFilter);
  };

  const handleTemplateChange = (_, newValue) => {
    setTemplateFilters(newValue);
    toggleIsUsingTemplateFilter(true);
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Checkbox
          sx={{ marginLeft: -3 }}
          checked={isUsingTemplateFilter}
          onChange={handleToggleTemplateFilter}
        />
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, marginRight: 1 }}
        >
          Filter by Templates
        </Typography>
      </Box>
      {isUsingTemplateFilter ? (
        <Box sx={{ paddingRight: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              height: "72px",
              width: "35%",
              borderRadius: 2,
              backgroundColor: (theme) => theme.palette.terrain[200],
              border: "1px solid",
              borderColor: (theme) => theme.palette.terrain[300],
              padding: 2,
              marginTop: 2,
            }}
          >
            <Autocomplete
              size="small"
              multiple
              fullWidth
              options={templates}
              getOptionLabel={(option) => option.name}
              disableCloseOnSelect
              renderTags={() => null}
              value={templateFilters}
              onChange={handleTemplateChange}
              disabled={templates.length === 0}
              sx={{
                "& .MuiAutocomplete-inputRoot": {
                  "&:hover": {
                    cursor: templates.length === 0 ? "not-allowed" : "pointer",
                  },
                },
                "& .MuiAutocomplete-option": {
                  "&:hover": {
                    cursor: "pointer",
                  },
                },
              }}
              renderOption={(props, option) => (
                <ListItem
                  sx={{
                    "&:hover": {
                      color: (theme) => theme.palette.pure.white,
                    },
                  }}
                  key={option.id}
                  {...props}
                >
                  <Checkbox
                    sx={{ color: (theme) => theme.palette.primary[800] }}
                    checked={templateFilters.some(
                      (item) => item.id === option.id
                    )}
                    onChange={() => {}}
                  />
                  <ListItemText primary={option.name} />
                </ListItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder={
                    templates.length === 0
                      ? "No Templates Found"
                      : templateFilters?.length > 0
                      ? `${templateFilters.length} Template(s) Selected`
                      : "No Templates Selected"
                  }
                  inputProps={{
                    ...params.inputProps,
                    readOnly: true,
                    style: { cursor: templates.length === 0 ? "not-allowed" : "pointer" },
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    width: "100%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    cursor: templates.length === 0 ? "not-allowed" : "pointer",
                  }}
                />
              )}
            />
          </Box>
          {isUsingTemplateFilter ? (
            <Box sx={{ marginTop: 2 }}>
              {templateFilters.map((t) => (
                <Chip
                  key={t.id}
                  label={t.name}
                  onDelete={() => {
                    setTemplateFilters(
                      templateFilters.filter((item) => item.id !== t.id)
                    );
                  }}
                  sx={{ marginRight: 1, marginBottom: 1 }}
                />
              ))}
            </Box>
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
};

export default TemplateFilters;
